import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

import { usePatientLayoutContext } from "@src/deprecated/routes/layouts/patient";
import { useEncounterId } from "@src/features/encounters";
import { Textarea } from "@src/shared/components/forms/Textarea";
import { HeaderText } from "@src/shared/components/general/HeaderText";
import { SectionHeader } from "@src/shared/components/general/SectionHeader";
import {
  Flexbox,
  VerticalFlexbox,
} from "@src/shared/components/layout/Flexbox";
import { navigation } from "@src/shared/navigation";
import { events } from "@src/shared/utils/observability/events";

import { Agenda } from "./components/Agenda";

export interface TodayPageProps {
  isFallbackPolling?: boolean;
}

export const TodayPage = ({ isFallbackPolling }: TodayPageProps) => {
  const [notepad, setNotepad] = useState("");

  const { patientId } = usePatientLayoutContext();
  const encounterId = useEncounterId();

  useEffect(() => {
    events.openAgenda.track();
  }, []);

  if (!patientId) {
    return <Navigate to={navigation.dashboardNotFound()} />;
  }

  const patientIdNum = Number.parseInt(patientId, 10);
  const patientIdForAgenda =
    Number.isFinite(patientIdNum) && patientIdNum > 0
      ? patientIdNum
      : undefined;

  return (
    <VerticalFlexbox
      gap="md"
      className="min-h-0 flex-1 px-4 py-6 md-stitch:px-8 md-stitch:py-8"
    >
      <HeaderText tag="h2">Today</HeaderText>
      <Flexbox gap="lg" className="flex-1 flex-col lg-stitch:flex-row">
        <VerticalFlexbox gap="sm" className="min-w-0 flex-1">
          <SectionHeader>Agenda</SectionHeader>
          <Agenda
            encounterId={encounterId ?? undefined}
            patientId={patientIdForAgenda}
            isFallbackPolling={isFallbackPolling}
          />
        </VerticalFlexbox>
        <VerticalFlexbox gap="sm" className="min-w-0 flex-1">
          <SectionHeader>Scratchpad</SectionHeader>
          <VerticalFlexbox gap="xs" className="min-h-0 flex-1">
            <Textarea
              placeholder="Jot down notes for this visit…"
              value={notepad}
              onChange={(e) => setNotepad(e.target.value)}
              fillHeight
              fillWidth
            />
          </VerticalFlexbox>
        </VerticalFlexbox>
      </Flexbox>
    </VerticalFlexbox>
  );
};
